// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TutorialPage.css - Styles for the generated tutorial page */

.tutorial-page {
  min-height: 100vh;
  background: #f8f9fa;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
}

/* Header */
.tutorial-header {
  background: white;
  border-bottom: 1px solid #e9ecef;
  padding: 20px 0;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.tutorial-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.back-button {
  background: #6c757d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1em;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
}

.back-button:hover {
  background: #5a6268;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.tutorial-meta {
  display: flex;
  gap: 15px;
  font-size: 0.9em;
  color: #6c757d;
}

.tutorial-date,
.tutorial-updated {
  padding: 5px 10px;
  background: #f8f9fa;
  border-radius: 5px;
  border: 1px solid #e9ecef;
}

/* Main Content */
.tutorial-main {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

/* CRM-friendly metadata boxes */
.tutorial-metadata {
  background: white;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  padding: 30px;
  margin-bottom: 30px;
  border: 1px solid #e9ecef;
}

.metadata-box {
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.metadata-box:last-child {
  margin-bottom: 0;
}

.metadata-label {
  display: block;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
  font-size: 0.9em;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.metadata-content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: white;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #dee2e6;
}

.metadata-text {
  flex: 1 1;
  font-family: 'Courier New', monospace;
  font-size: 0.9em;
  color: #212529;
  word-break: break-word;
  line-height: 1.4;
}

.metadata-text.truncated {
  color: #6c757d;
  font-style: italic;
}

.copy-button {
  background: #667eea;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8em;
  font-weight: 500;
  transition: all 0.3s ease;
  white-space: nowrap;
  min-width: 80px;
}

.copy-button:hover {
  background: #5a6fd8;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.copy-button:active {
  transform: translateY(0);
}

.copy-buttons-group {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.copy-button.html-copy {
  background: #28a745;
  color: white;
}

.copy-button.html-copy:hover {
  background: #218838;
}

.tutorial-article {
  background: white;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.article-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 40px 40px 30px;
  text-align: center;
}

.tutorial-title {
  font-size: 2.5em;
  margin: 0 0 15px 0;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.tutorial-description {
  font-size: 1.2em;
  margin: 0;
  opacity: 0.9;
  font-weight: 300;
  max-width: 800px;
  margin: 0 auto;
}

/* Tutorial Content */
.tutorial-content {
  padding: 40px;
  font-size: 1.1em;
  line-height: 1.8;
}

.tutorial-content h1,
.tutorial-content h2,
.tutorial-content h3,
.tutorial-content h4,
.tutorial-content h5,
.tutorial-content h6 {
  color: #2c3e50;
  margin-top: 40px;
  margin-bottom: 20px;
  font-weight: 600;
}

.tutorial-content h1 {
  font-size: 2.2em;
  border-bottom: 3px solid #667eea;
  padding-bottom: 15px;
}

.tutorial-content h2 {
  font-size: 1.8em;
  color: #667eea;
}

.tutorial-content h3 {
  font-size: 1.5em;
  color: #764ba2;
}

.tutorial-content p {
  margin-bottom: 20px;
  text-align: justify;
}

.tutorial-content ul,
.tutorial-content ol {
  margin-bottom: 20px;
  padding-left: 30px;
}

.tutorial-content li {
  margin-bottom: 10px;
}

.tutorial-content blockquote {
  background: #f8f9fa;
  border-left: 4px solid #667eea;
  padding: 20px 30px;
  margin: 30px 0;
  font-style: italic;
  font-size: 1.1em;
  border-radius: 0 8px 8px 0;
}

.tutorial-content code {
  background: #f8f9fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  color: #e83e8c;
  font-size: 0.9em;
}

.tutorial-content pre {
  background: #2d3748;
  color: #e2e8f0;
  padding: 20px;
  border-radius: 8px;
  overflow-x: auto;
  margin: 20px 0;
  font-family: 'Courier New', monospace;
}

.tutorial-content pre code {
  background: none;
  padding: 0;
  color: inherit;
  font-size: 1em;
}

/* Step styling */
.tutorial-content .step {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 25px;
  margin: 25px 0;
  border-left: 5px solid #667eea;
}

.tutorial-content .step h3 {
  color: #667eea;
  margin-top: 0;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.tutorial-content .step h3:before {
  content: "▶";
  color: #764ba2;
  font-size: 0.8em;
}

/* Image styling */
.tutorial-content img,
.tutorial-image {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  margin: 20px 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.tutorial-step-image {
  text-align: center;
  margin: 30px 0;
  padding: 0;
  background: none;
  border: none;
  box-shadow: none;
  border-radius: 0;
}

.tutorial-step-image img {
  margin: 0;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border: 2px solid white;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.tutorial-step-image img:hover {
  transform: scale(1.02);
}

.image-caption {
  margin-top: 10px;
  margin-bottom: 5px;
  font-style: italic;
  color: #6c757d;
  font-size: 0.9em;
  text-align: center;
  display: block;
}

.frame-description {
  margin-top: 5px;
  margin-bottom: 0;
  color: #495057;
  font-size: 0.95em;
  text-align: center;
  font-style: normal;
}

/* Remove step containers for seamless flow */
.step-container {
  margin: 0;
  padding: 0;
  background: none;
  border: none;
  box-shadow: none;
  border-radius: 0;
}

/* Natural paragraph styling */
.tutorial-content p {
  margin-bottom: 20px;
  text-align: left;
  line-height: 1.7;
}

/* Step headings blend naturally */
.tutorial-content h3 {
  font-size: 1.3em;
  color: #2c3e50;
  margin-top: 35px;
  margin-bottom: 15px;
  font-weight: 600;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 8px;
}

/* Remove artificial step indicators */
.step-container h3:before {
  display: none;
}

/* Footer */
.tutorial-footer {
  background: white;
  border-top: 1px solid #e9ecef;
  padding: 30px 0;
  margin-top: 50px;
}

.tutorial-actions {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: center;
  gap: 20px;
}

.action-button {
  padding: 12px 25px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1em;
  font-weight: 600;
  transition: all 0.3s ease;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 180px;
  white-space: nowrap;
}

.action-button.primary {
  background: linear-gradient(45deg, #667eea, #764ba2);
  color: white;
}

.action-button.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.action-button.secondary {
  background: #6c757d;
  color: white;
}

.action-button.secondary:hover {
  background: #5a6268;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.action-button.regenerate {
  background: #28a745;
  color: white;
}

.action-button.regenerate:hover:not(:disabled) {
  background: #218838;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}

.action-button.regenerate:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.action-button.regenerate:disabled:hover {
  transform: none;
  box-shadow: none;
}

.action-button.download {
  background: #007bff;
  color: white;
}

.action-button.download:hover:not(:disabled) {
  background: #0056b3;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
}

.action-button.download:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.action-button.download:disabled:hover {
  transform: none;
  box-shadow: none;
}

/* Loading and Error States */
.tutorial-loading,
.tutorial-error,
.tutorial-not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
  padding: 40px;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #e9ecef;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.tutorial-loading p,
.tutorial-error p,
.tutorial-not-found p {
  font-size: 1.2em;
  color: #6c757d;
  margin: 20px 0;
}

.tutorial-error h2,
.tutorial-not-found h2 {
  color: #dc3545;
  margin-bottom: 15px;
}

/* Print Styles */
@media print {
  .tutorial-header,
  .tutorial-footer {
    display: none;
  }
  
  .tutorial-page {
    background: white;
  }
  
  .tutorial-article {
    box-shadow: none;
    border-radius: 0;
  }
  
  .tutorial-content {
    padding: 20px;
  }
  
  .article-header {
    background: white !important;
    color: black !important;
    -webkit-print-color-adjust: exact;
  }
  
  .tutorial-title {
    text-shadow: none;
    color: black !important;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .tutorial-nav {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
  
  .tutorial-meta {
    flex-direction: column;
    gap: 10px;
  }
  
  .tutorial-main {
    padding: 20px 15px;
  }
  
  .article-header {
    padding: 30px 20px 20px;
  }
  
  .tutorial-title {
    font-size: 2em;
  }
  
  .tutorial-description {
    font-size: 1.1em;
  }
  
  .tutorial-content {
    padding: 30px 20px;
    font-size: 1em;
  }
  
  .tutorial-actions {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  .action-button {
    width: 220px;
    justify-content: center;
  }
  
  .tutorial-metadata {
    padding: 20px;
    margin-bottom: 20px;
  }
  
  .metadata-content {
    flex-direction: column;
    gap: 10px;
  }
  
  .copy-button {
    align-self: flex-start;
    min-width: 100px;
  }
}`, "",{"version":3,"sources":["webpack://./src/TutorialPage.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D;EACE,iBAAiB;EACjB,mBAAmB;EACnB,4DAA4D;EAC5D,gBAAgB;EAChB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;;;EAME,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;;EAEE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,aAAa;AACf;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;;;EAGE,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;AACF","sourcesContent":["/* TutorialPage.css - Styles for the generated tutorial page */\n\n.tutorial-page {\n  min-height: 100vh;\n  background: #f8f9fa;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  line-height: 1.6;\n  color: #333;\n}\n\n/* Header */\n.tutorial-header {\n  background: white;\n  border-bottom: 1px solid #e9ecef;\n  padding: 20px 0;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.tutorial-nav {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.back-button {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1em;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  text-decoration: none;\n}\n\n.back-button:hover {\n  background: #5a6268;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.tutorial-meta {\n  display: flex;\n  gap: 15px;\n  font-size: 0.9em;\n  color: #6c757d;\n}\n\n.tutorial-date,\n.tutorial-updated {\n  padding: 5px 10px;\n  background: #f8f9fa;\n  border-radius: 5px;\n  border: 1px solid #e9ecef;\n}\n\n/* Main Content */\n.tutorial-main {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 40px 20px;\n}\n\n/* CRM-friendly metadata boxes */\n.tutorial-metadata {\n  background: white;\n  border-radius: 15px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  padding: 30px;\n  margin-bottom: 30px;\n  border: 1px solid #e9ecef;\n}\n\n.metadata-box {\n  margin-bottom: 20px;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.metadata-box:last-child {\n  margin-bottom: 0;\n}\n\n.metadata-label {\n  display: block;\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 8px;\n  font-size: 0.9em;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.metadata-content {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  background: white;\n  padding: 12px;\n  border-radius: 6px;\n  border: 1px solid #dee2e6;\n}\n\n.metadata-text {\n  flex: 1;\n  font-family: 'Courier New', monospace;\n  font-size: 0.9em;\n  color: #212529;\n  word-break: break-word;\n  line-height: 1.4;\n}\n\n.metadata-text.truncated {\n  color: #6c757d;\n  font-style: italic;\n}\n\n.copy-button {\n  background: #667eea;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8em;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  min-width: 80px;\n}\n\n.copy-button:hover {\n  background: #5a6fd8;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n}\n\n.copy-button:active {\n  transform: translateY(0);\n}\n\n.copy-buttons-group {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.copy-button.html-copy {\n  background: #28a745;\n  color: white;\n}\n\n.copy-button.html-copy:hover {\n  background: #218838;\n}\n\n.tutorial-article {\n  background: white;\n  border-radius: 15px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.article-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 40px 40px 30px;\n  text-align: center;\n}\n\n.tutorial-title {\n  font-size: 2.5em;\n  margin: 0 0 15px 0;\n  font-weight: 700;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.tutorial-description {\n  font-size: 1.2em;\n  margin: 0;\n  opacity: 0.9;\n  font-weight: 300;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n/* Tutorial Content */\n.tutorial-content {\n  padding: 40px;\n  font-size: 1.1em;\n  line-height: 1.8;\n}\n\n.tutorial-content h1,\n.tutorial-content h2,\n.tutorial-content h3,\n.tutorial-content h4,\n.tutorial-content h5,\n.tutorial-content h6 {\n  color: #2c3e50;\n  margin-top: 40px;\n  margin-bottom: 20px;\n  font-weight: 600;\n}\n\n.tutorial-content h1 {\n  font-size: 2.2em;\n  border-bottom: 3px solid #667eea;\n  padding-bottom: 15px;\n}\n\n.tutorial-content h2 {\n  font-size: 1.8em;\n  color: #667eea;\n}\n\n.tutorial-content h3 {\n  font-size: 1.5em;\n  color: #764ba2;\n}\n\n.tutorial-content p {\n  margin-bottom: 20px;\n  text-align: justify;\n}\n\n.tutorial-content ul,\n.tutorial-content ol {\n  margin-bottom: 20px;\n  padding-left: 30px;\n}\n\n.tutorial-content li {\n  margin-bottom: 10px;\n}\n\n.tutorial-content blockquote {\n  background: #f8f9fa;\n  border-left: 4px solid #667eea;\n  padding: 20px 30px;\n  margin: 30px 0;\n  font-style: italic;\n  font-size: 1.1em;\n  border-radius: 0 8px 8px 0;\n}\n\n.tutorial-content code {\n  background: #f8f9fa;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: 'Courier New', monospace;\n  color: #e83e8c;\n  font-size: 0.9em;\n}\n\n.tutorial-content pre {\n  background: #2d3748;\n  color: #e2e8f0;\n  padding: 20px;\n  border-radius: 8px;\n  overflow-x: auto;\n  margin: 20px 0;\n  font-family: 'Courier New', monospace;\n}\n\n.tutorial-content pre code {\n  background: none;\n  padding: 0;\n  color: inherit;\n  font-size: 1em;\n}\n\n/* Step styling */\n.tutorial-content .step {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 10px;\n  padding: 25px;\n  margin: 25px 0;\n  border-left: 5px solid #667eea;\n}\n\n.tutorial-content .step h3 {\n  color: #667eea;\n  margin-top: 0;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.tutorial-content .step h3:before {\n  content: \"▶\";\n  color: #764ba2;\n  font-size: 0.8em;\n}\n\n/* Image styling */\n.tutorial-content img,\n.tutorial-image {\n  max-width: 100%;\n  height: auto;\n  border-radius: 10px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  margin: 20px 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.tutorial-step-image {\n  text-align: center;\n  margin: 30px 0;\n  padding: 0;\n  background: none;\n  border: none;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n.tutorial-step-image img {\n  margin: 0;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  border: 2px solid white;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n.tutorial-step-image img:hover {\n  transform: scale(1.02);\n}\n\n.image-caption {\n  margin-top: 10px;\n  margin-bottom: 5px;\n  font-style: italic;\n  color: #6c757d;\n  font-size: 0.9em;\n  text-align: center;\n  display: block;\n}\n\n.frame-description {\n  margin-top: 5px;\n  margin-bottom: 0;\n  color: #495057;\n  font-size: 0.95em;\n  text-align: center;\n  font-style: normal;\n}\n\n/* Remove step containers for seamless flow */\n.step-container {\n  margin: 0;\n  padding: 0;\n  background: none;\n  border: none;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n/* Natural paragraph styling */\n.tutorial-content p {\n  margin-bottom: 20px;\n  text-align: left;\n  line-height: 1.7;\n}\n\n/* Step headings blend naturally */\n.tutorial-content h3 {\n  font-size: 1.3em;\n  color: #2c3e50;\n  margin-top: 35px;\n  margin-bottom: 15px;\n  font-weight: 600;\n  border-bottom: 1px solid #e9ecef;\n  padding-bottom: 8px;\n}\n\n/* Remove artificial step indicators */\n.step-container h3:before {\n  display: none;\n}\n\n/* Footer */\n.tutorial-footer {\n  background: white;\n  border-top: 1px solid #e9ecef;\n  padding: 30px 0;\n  margin-top: 50px;\n}\n\n.tutorial-actions {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n}\n\n.action-button {\n  padding: 12px 25px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1em;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-width: 180px;\n  white-space: nowrap;\n}\n\n.action-button.primary {\n  background: linear-gradient(45deg, #667eea, #764ba2);\n  color: white;\n}\n\n.action-button.primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.action-button.secondary {\n  background: #6c757d;\n  color: white;\n}\n\n.action-button.secondary:hover {\n  background: #5a6268;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.action-button.regenerate {\n  background: #28a745;\n  color: white;\n}\n\n.action-button.regenerate:hover:not(:disabled) {\n  background: #218838;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);\n}\n\n.action-button.regenerate:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.action-button.regenerate:disabled:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n.action-button.download {\n  background: #007bff;\n  color: white;\n}\n\n.action-button.download:hover:not(:disabled) {\n  background: #0056b3;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);\n}\n\n.action-button.download:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.action-button.download:disabled:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n/* Loading and Error States */\n.tutorial-loading,\n.tutorial-error,\n.tutorial-not-found {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  text-align: center;\n  padding: 40px;\n}\n\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid #e9ecef;\n  border-top: 4px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.tutorial-loading p,\n.tutorial-error p,\n.tutorial-not-found p {\n  font-size: 1.2em;\n  color: #6c757d;\n  margin: 20px 0;\n}\n\n.tutorial-error h2,\n.tutorial-not-found h2 {\n  color: #dc3545;\n  margin-bottom: 15px;\n}\n\n/* Print Styles */\n@media print {\n  .tutorial-header,\n  .tutorial-footer {\n    display: none;\n  }\n  \n  .tutorial-page {\n    background: white;\n  }\n  \n  .tutorial-article {\n    box-shadow: none;\n    border-radius: 0;\n  }\n  \n  .tutorial-content {\n    padding: 20px;\n  }\n  \n  .article-header {\n    background: white !important;\n    color: black !important;\n    -webkit-print-color-adjust: exact;\n  }\n  \n  .tutorial-title {\n    text-shadow: none;\n    color: black !important;\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .tutorial-nav {\n    flex-direction: column;\n    gap: 15px;\n    text-align: center;\n  }\n  \n  .tutorial-meta {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .tutorial-main {\n    padding: 20px 15px;\n  }\n  \n  .article-header {\n    padding: 30px 20px 20px;\n  }\n  \n  .tutorial-title {\n    font-size: 2em;\n  }\n  \n  .tutorial-description {\n    font-size: 1.1em;\n  }\n  \n  .tutorial-content {\n    padding: 30px 20px;\n    font-size: 1em;\n  }\n  \n  .tutorial-actions {\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n  }\n\n  .action-button {\n    width: 220px;\n    justify-content: center;\n  }\n  \n  .tutorial-metadata {\n    padding: 20px;\n    margin-bottom: 20px;\n  }\n  \n  .metadata-content {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .copy-button {\n    align-self: flex-start;\n    min-width: 100px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
